module.exports = __webpack_public_path__ + "static/img/tjbg.7c61224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tjbg.png
// module id = stat
// module chunks = 17